<!-- HEADER -->
<app-header color="transparent"></app-header>

<ion-content class="padded">
  <section>
    <!-- BREADCRUMBS -->
    <ul class="breadcrumb">
      <li>
        <a [routerLink]="'/'">Home</a
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <a [routerLink]="'/events'">Events</a
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li class="active">{{data.title}}</li>
    </ul>

    <!-- HEADING, SOCIAL SHARING & FAVORITE -->
    <ion-grid class="page-header ion-no-padding">
      <ion-row>
        <ion-col>
          <ion-text color="dark">
            <h1 class="h2 page-title">{{data.title}}</h1>
          </ion-text>
        </ion-col>
        <ion-col size="auto" class="page-header-actions">
          <ion-row class="ion-align-items-center ion-justify-content-end">
            <!-- SOCIAL SHARING -->
            <ion-col size="auto" class="social-share">
              <a (click)="presentPopover($event)">
                <ion-icon
                  color="dark"
                  name="share-outline"
                  slot="icon-only"
                ></ion-icon>
              </a>
            </ion-col>
            <!-- FAVORTIE -->
            <ion-col size="auto" class="favorite">
              <app-favorite-item
                [title]="data.title"
                [slug]="data.slug"
              ></app-favorite-item>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- FEATURED IMAGE -->
    <app-image
      [node]="featuredImage"
      [disableLazyLoad]="true"
      class="event-featured-image"
      [sponsor]="data?.advertise"
    ></app-image>

    <!-- EVENT DETAILS -->
    <ion-grid class="event-details">
      <ion-row>
        <ion-col size="6" size-md="3">
          <ion-text color="medium">
            <p class="event-detail-heading ion-no-margin">Date</p>
          </ion-text>
          <ng-container *ngIf="!sameDay; else singleDayEvent">
            {{startDate | date:'d MMM'}} - {{endDate | date:'d MMM'}}
          </ng-container>
          <ng-template #singleDayEvent>
            {{startDate | date:'d MMM'}}
          </ng-template>
        </ion-col>
        <ion-col size="6" size-md="3">
          <ion-text color="medium">
            <p class="event-detail-heading ion-no-margin">Time</p>
          </ion-text>
          {{startDate | date:'H:mm'}} <span *ngIf="(startDate | date:'H:mm') != (endDate | date:'H:mm')">- {{endDate | date:'H:mm'}}</span>
        </ion-col>
        <ion-col size="6" size-md="3">
          <ng-container *ngIf="data.typeSettings?.costText">
            <ion-text color="medium">
              <p class="event-detail-heading ion-no-margin">Price</p>
            </ion-text>
            {{data.typeSettings.costText}}
          </ng-container>
        </ion-col>
        <ion-col size-md="3" class="ion-hide-md-down ion-text-right">
          <app-button *ngIf="data.typeSettings?.ctaText" 
            [href]="ctaUrl"
            target="_blank" [icon]="{ name: 'arrow-right', position: 'right' }">
            {{ data.typeSettings.ctaText }}
          </app-button>
        </ion-col>
        <ion-col size="6" size-md="3">
          <ion-text color="medium">
            <p class="event-detail-heading ion-no-margin">Venue</p>
          </ion-text>
          {{ data.typeSettings.relatedText &&
          data.typeSettings.relatedText.length > 0 ?
          data.typeSettings.relatedText : data.eventContext?.title ?
          data.eventContext.title : 'Centre-Wide' }}
        </ion-col>
        <ion-col
          *ngIf="data.typeSettings?.additionalInfo"
          size="12"
          size-md="6"
        >
          <ion-text color="medium">
            <p class="event-detail-heading ion-no-margin">Details</p>
          </ion-text>
          <div
            [innerHTML]="data.typeSettings.additionalInfo"
            class="event-additional-info"
          ></div>
        </ion-col>
        <ion-col *ngIf="ctaUrl" size="12" class="ion-hide-md-up">
          <app-button
            [href]="ctaUrl"
            target="_blank" [icon]="{ name: 'arrow-right', position: 'right' }">
            {{ data.typeSettings.ctaText }}
          </app-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- BODY -->
    <app-dynamic-html
      [data]="data?.body"
      [formTitle]="data.title"
    ></app-dynamic-html>

    <!-- SPONSOR STRIP -->
    <app-sponsor-strip
      *ngIf="data?.advertise"
      [sponsorStrip]="data?.advertise"
    ></app-sponsor-strip>

    <!-- RELATED CONTENT -->
    <section *ngIf="relatedContent && relatedContent.length > 0">
      <app-related-content
        [data]="{title: 'More Events', items: relatedContent }"
        [showType]="true"
        [hideCategory]="true"
      ></app-related-content>
    </section>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
